import * as React from 'react';

import Auth from 'components/Auth';
import MetaTagsComponent from 'components/MetaTags';
import { useAuth } from 'utils/customHooks/auth';
import { isNonNoodleInstance } from 'utils/privateLabel/index';

import { StyledTitle } from './PasswordReset.styles';

const PasswordResetMetaTags: React.FC = () => {
  const title = 'Reset Your Password';
  const description = 'Set or reset your account password to access your account.';

  return <MetaTagsComponent title={title} description={description} ogTitle={title} />;
};

const PasswordReset: React.FC = () => {
  const { configureAuth0Lock } = useAuth();

  React.useEffect(() => {
    const auth0Lock = configureAuth0Lock();
    auth0Lock.hide();
    auth0Lock.show({
      initialScreen: 'forgotPassword',
    });
    auth0Lock.on('signin ready', () => {
      const tabsContainer: Record<string, any> = document.querySelector(
        '.auth0-lock-tabs-container',
      );

      if (isNonNoodleInstance) {
        // Removing tabs
        tabsContainer?.remove();
      } else {
        tabsContainer.parentElement.classList.add('auth__reset-password__no-padding');
      }
    });
  }, []);

  return (
    <Auth role='main' id='main-id'>
      <PasswordResetMetaTags />
      <Auth.Logo />
      <Auth.Header role='banner'>
        <StyledTitle role='heading' aria-level='1'>
          Set New Password
        </StyledTitle>
      </Auth.Header>
      <Auth.Body className='auth__reset-password' aria-live='polite' />
    </Auth>
  );
};

export default PasswordReset;
